module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNDM4NyA2LjEyMTM0QzAuMTk2NDEzIDMuMzcwNTcgMi4yMjk5NCAwLjk0NDIxMiA0Ljk4MDcyIDAuNzAxOTI1TDEyLjk0OTkgMy44ODE3NWUtMDZMMTMuNjUxOCA3Ljk2OTE1QzEzLjg5NDEgMTAuNzE5OSAxMS44NjA1IDEzLjE0NjMgOS4xMDk3NyAxMy4zODg2TDEuMTQwNjIgMTQuMDkwNUwwLjQzODcgNi4xMjEzNFoiIGZpbGw9IiM4ODBFNEYiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/puce.svg
// module id = 43
// module chunks = 1